import React from 'react';
import Advertorial from './components/Advertorial';
import GlobalFallback from './components/GlobalFallback';
export function App() {
  return <div className="w-full min-h-full bg-white" data-id="element-0">
      <Advertorial data-id="element-1" />
      <GlobalFallback data-id="element-2" />
    </div>;
}